<div fxLayout="column" fxLayoutGap="10px">
  <div class="flex-row gap-8 align-center">
    <span class="title">Rewarding rules</span>
    <lib-button (buttonClick)="addRule()" tooltip="Add new rule" icon="add">Add rule</lib-button>
  </div>
  @for (rule of openerSchemeRewardRules; track rule; let i = $index) {
    <div>
      <app-opener-scheme-rule-edit
        [ruleIndex]="i"
        [rule]="rule"
        (onSaveRule)="onSaveRule($event)"
        (onRemoveRule)="onRemoveRule($event)">
      </app-opener-scheme-rule-edit>
    </div>
  }
</div>